import { createSelector } from 'reselect';
import _ from 'lodash';
import { getSupportedDeliveryTypes } from '../../../utils/OrderUtils';

const inputSelectors = [state => _.get(state, 'order.deliveryType'), state => state.session.organization];

export function deliveryTypeSelectorFn(deliveryType, organization) {
  return deliveryType || _.first(_.sortBy(getSupportedDeliveryTypes(organization)));
}

export const deliveryTypeSelector = createSelector(
  inputSelectors,
  deliveryTypeSelectorFn,
);
